import { Stack, Text } from '@/theme/index';

export const RepairQuotesHowItWorks = () => {
  return (
    <Stack
      direction="column"
      fontSize="0.9rem"
      spacing={1}
      color={(theme) => theme.palette.grey[800]}
      data-testid="how-it-works-repair-quotes"
    >
      <Text variant="body2" component="span">
        The repair quotes provided in this section are sourced from a nationwide
        network of automotive repair shops. This data may include estimated
        repair costs, parts information, labor times, repair shop locations, and
        insurance details. Use this information to assess the severity of
        previous damages and make informed decisions about the vehicle's
        condition. However, this information should not be substituted for your
        own due diligence and actual quotes may vary.
      </Text>
    </Stack>
  );
};
